import SKEvent from 'Root/classes/SKEvent';

export default {
  BOOSTER: {
    LOGOUT: new SKEvent('boosterLogout'),
  },

  POPUP: {
    OPEN: new SKEvent('popupOpen'),
    CLOSE: new SKEvent('popupClose'),
  },

  NATIVE: {
    TAB: {
      ACTIVATED: new SKEvent('native.tab.activated'),
      DEACTIVATED: new SKEvent('native.tab.deactivated'),
    },
  },
};
